var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M1.51328 10.4167C0.396615 8.99667 0.396615 7.00267 1.51328 5.58267C2.82395 3.91667 4.98661 2 8.00061 2C11.0146 2 13.1773 3.91667 14.4879 5.58333C15.6046 7.00333 15.6046 8.99733 14.4879 10.4173C13.1773 12.0833 11.0146 14 8.00061 14C4.98661 14 2.82395 12.0833 1.51328 10.4167Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4C5.79067 4 4 5.79067 4 8C4 10.2093 5.79067 12 8 12C10.2093 12 12 10.2093 12 8C12 5.79067 10.2093 4 8 4ZM8.66667 8.66667C7.93 8.66667 7.33333 8.07 7.33333 7.33333C7.33333 6.59667 7.93 6 8.66667 6C9.40333 6 10 6.59667 10 7.33333C10 8.07 9.40333 8.66667 8.66667 8.66667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.021acb9c02b1ffb3eda50bda36fa45ba.svg";
export { ForwardRef as ReactComponent };